import React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';

import { photoLocations } from '../data/photoLocations';

const PhotoLightbox = ({ open, photo, onClose }) => {
    const location = photo
        ? photoLocations[`${photo.category}/${photo.filename}`] ||
          photoLocations[photo.filename]
        : undefined;

    const slides = photo
        ? [
              {
                  src: photo.src,
                  alt: photo.filename,
                  ...(location ? { description: location } : {}),
              },
          ]
        : [];

    return (
        <Lightbox
            open={open}
            close={onClose}
            index={0}
            slides={slides}
            plugins={[Zoom, Captions]}
            carousel={{ finite: true }}
            controller={{
                closeOnBackdropClick: true,
                closeOnPullDown: true,
            }}
            render={{
                buttonPrev: () => null,
                buttonNext: () => null,
            }}
            zoom={{
                maxZoomPixelRatio: 3,
                scrollToZoom: true,
            }}
            captions={{
                descriptionTextAlign: 'end',
                descriptionMaxLines: 3,
                showToggle: false,
            }}
            styles={{
                container: { backgroundColor: 'rgba(0, 0, 0, 0.92)' },
            }}
            className="photo-lightbox"
        />
    );
};

export default PhotoLightbox;
